/* eslint-disable */
import { $http, formatStr } from "@/assets/js/appFunc";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import { extend, uid, Dialog } from "quasar";

import i18n from "@/i18n";

const urls = {
    latestVersion: "/engine/api/version/latest",
    dataModel: "/data/model/versions/{0}/applications/{1}",
    dataModelNew: "/design/dataModel?applicationId={0}",
    applicationInterfaces: " /design/guis?applicationId={0}",
    coreAPIs: "/ws",
    interfaceModel: "/design/guis/{0}?applicationId={1}",
    interfaceModelStart: "/gui/{0}",
    loadInterfaceData: "/engine/api/data/load/gui",
    saveInterfaceData: "/engine/api/data/save/gui",
    getActions: "/engine/api/flow/activity/{0}/actions",
    guiSave: "/design/guis/persist",
    guiSubmit: "/engine/api/flow/guiSubmit",
    guiApprovalSubmit: "/engine/api/flow/approvalSubmit",
    guiRemove: "/design/guis/{0}",
    catalogLoad: "/data/catalogs/content/load/version/{0}/application/{1}",
    claimTask: "/engine/task/claim/by/{0}",
    apiIntegration: "/integration/ws/version/{0}/application/{1}/webservice/{2}/operation/{3}",
    apiTesting: "/design/apis/{0}/methods/{1}/test?applicationId={2}",
    systemVariables: "/engine/api/variables",
    systemTasksVariablesExtended: "/engine/api/variables/tasks/reports/export",
    systemInstancesVariablesExtended: "/engine/api/variables/instances/reports/export"
};

const backwardsCompatibilityUpdates = interfaceData => {
    const { components = {} } = interfaceData.interfaceJson || {};
    Object.entries(components).forEach(([key, data]) => {
        const { __component } = data;
        if (__component === "ctrl-textbox" || __component === "ctrl-textarea") {
            if (!data.hasOwnProperty("__validations")) {
                data["__validations"] = {};
            }
        } else if (__component === "ctrl-data-table") {
            // update columns per formatting update
            const { columns } = data;
            columns.forEach(entry => {
                const { _meta } = entry;

                if (!entry.hasOwnProperty("hide")) {
                    entry.hide = false;
                }
                if (!entry.hasOwnProperty("wrapText")) {
                    entry.wrapText = false;
                }
                if (!entry.hasOwnProperty("flex")) {
                    entry.flex = 1;
                }
                if (!entry.hasOwnProperty("minWidth")) {
                    entry.minWidth = 15 + (entry.headerName || "").length * 16;
                }

                // delete entry.flex;
                // delete entry.width;
                // delete entry.minWidth;
                // delete entry.maxWidth;

                // entry.flex = null;
                // entry.width = null;
                // entry.maxWidth = null
                // entry.minWidth = null;
                entry.initialHide = entry.hide;
                if (!_meta) {
                    entry._meta = {
                        format: { type: "", decimal: ".", thousands: "," }
                    };
                }
            });
        }
    });
};

export const getDataModelLatestVersion = store => {
    if (store.state.latestVersion) {
        return Promise.resolve(store.state.latestVersion);
    }
    return $http({ url: urls.latestVersion, type: "GET" }, true).then(({ data }) => {
        const id = data ? data.id : null;
        store.commit("latestVersion", id);
        return id;
    });
};

export const getRawDataModel = (store, startApp) =>
    new Promise(resolve => {
        const applicationId = store.rootState.apps.currentApp.id || store.rootState.main.currentApplicationId;
        const url = startApp ? formatStr(urls.dataModel, store.state.latestVersion, applicationId) : formatStr(urls.dataModelNew, applicationId);
        $http({ type: "GET", url: url }, true).then(({ data }) => {
            store.commit("rawDataModel", data);
            store.commit("parsedFirstTime", false);
            resolve(data);
        });
    });

export const getRawDataModelV2 = (store, payload) => {
    // const applicationId = store.rootState.apps.currentApp.id || store.rootState.main.currentApplicationId;
    const url = "/design/selector/datamodel/classes/paged";
    return $http({type: "POST", url, data: payload}, true);
}
export const getSystemVariablesModelV2 = (store, payload) => {
    let url = "/design/selector/system/variables/paged";
    if (payload.isReports) {
        url = "/design/selector/system/variables/reports/paged";
    }
    const data = {
        "from": 0,
        "to": 99999,
        "searchTerm": payload.searchTerm || ""
    }
    return $http({type: "POST", url, data}, true);
}
export const getSystemVariablesModelReportsV2 = (store, payload) => {
    return $http({type: "POST", url, data: payload}, true);
}

export const getLatestAppInterfaces = (store, appId) => {
    let promise;
    const applicationId = store.rootState.main.currentApplicationId || appId;

    if (applicationId) {
        const url = formatStr(urls.applicationInterfaces, applicationId);
        promise = $http({ type: "GET", url }, true);
        promise = promise.then(({ data }) => {
            store.commit("setAppInterfaces", data);
            store.commit("setLoadingInterfacesState", false);
            return data;
        });
    } else {
        store.commit("setAppInterfaces", []);
        store.commit("setLoadingInterfacesState", false);
        promise = Promise.resolve([]);
    }

    return promise;
};
export const guiRemove = (store, guid) => {
    const url = formatStr(urls.guiRemove, guid);

    return new Promise((resolve, reject) => {
        $http({ type: "DELETE", url }, true)
            .then(({ data }) => {
                if (data) {
                    store.commit("removeAppInterface", guid);
                    store.rootState.apps.currentApp.publishStatus = "UNPUBLISHED_CHANGES";
                    resolve();
                } else {
                    reject();
                }
            })
            .catch(() => {
                reject();
            });
    });
};
export const importInterface = (store, importedInterface) => {
    const applicationId = store.rootState.main.currentApplicationId;
    const versionId = store.state.latestVersion;

    if (applicationId && versionId) {
        const req = {
            type: "POST",
            url: `/design/guis/import?applicationId=${applicationId}&versionId=${versionId}`,
            data: importedInterface
        };

        return new Promise((resolve, reject) => {
            $http(req, true).then(
                data => {
                    resolve(data);
                },
                error => reject(error)
            );
        });
    }
};

export const loadFragments = (store, fragmentList, fromStart) => {
    let promise;
    if ((fragmentList || []).length) {
        promise = new Promise(resolve => {
            const fragmentPromises = [];
            fragmentList.forEach(fragment => {
               if (fromStart) {
                fragmentPromises.push(getInterfaceModel(store, { guid: fragment, fromStart }));
              } else if (Object.keys(store.state.fragments).length) {
                Object.keys(store.state.fragments).forEach((key) => {
                    if(fragment && fragment === key) {
                        fragmentPromises.push(getInterfaceModel(store, { guid: fragment, fromStart }));
                    }
                 })
              }
            });
            Promise.all(fragmentPromises).then(() => { resolve(); });
        });
    } else {
        promise = Promise.resolve(null);
    }

    return promise;
};
export const getInterfaceModel = (store, payload) => {
    const local = true;
    const guid = payload.guid || payload.guiId || payload;
    const update = payload && payload.update ? payload.update : false;
    const fromStart = payload && payload.fromStart ? payload.fromStart : false;
    const applicationId = store.rootState.apps.currentApp.id || store.rootState.main.currentApplicationId;

    let promise;
    if (guid) {
        if (local && store.state.interfaceModel.hasOwnProperty(guid) && !store.rootState.documentEditor.appUpdated && !update) {
            promise = Promise.resolve(extend(true, {}, store.state.interfaceModel[guid]));
        } else if (
            !store.state.interfaceModel.hasOwnProperty(guid) ||
            update ||
            (store.state.interfaceModel.hasOwnProperty(guid) && store.rootState.documentEditor.appUpdated)
        ) {
            const url = fromStart ? formatStr(urls.interfaceModelStart, guid) : formatStr(urls.interfaceModel, guid, applicationId);
            promise = new Promise(resolve => {
                    $http({ type: "GET", url, noNotify:true }, true).then(({ data }) => {
                            const { interfaceJson, interfaceInputModel, interfaceTestData, ...properties } = data;
                            if (!interfaceJson.config) {
                                interfaceJson.config = {};
                                interfaceJson.config.fragments = [];
                                interfaceJson.config.aiActions = [];
                            }
                            backwardsCompatibilityUpdates(data);
                            const dataModel = { model: { interfaceJson, interfaceInputModel, interfaceTestData }, dirty: false };
                            if (properties.type === "FRAGMENT") {
                                store.commit("addFragment", { id: guid, model: dataModel.model, data: properties });
                            }
                            store.commit("setInterfaceModel", { guid, dataModel });
                            if (interfaceJson) {
                                loadFragments(store, interfaceJson.config.fragments, fromStart).then(() => {
                                    resolve(extend(true, {}, dataModel, { properties }));
                                });
                                if (properties.type !== "FRAGMENT") {
                                    store.commit("setAiActions", interfaceJson.config.aiActions || []);
                                }
                            }
                    }, () => {
                        Vue.prototype.$toast.showNotify({
                                type: "error",
                                message:  i18n.t("userInterface.notFoundFr", { id: guid })
                            });
                        resolve(null);
                    })
            });
        }
    } else {
        promise = Promise.resolve(null);
    }

    return promise;
};

export const getRawInterfaceModel = (store, payload) => {
    const { guid } = payload;
    const applicationId = store.rootState.apps.currentApp.id || store.rootState.main.currentApplicationId;
    const url = formatStr(urls.interfaceModel, guid, applicationId);

    return $http({ type: "GET", url }, true);
};

const excludeFragments = (body, store, exclude = false) => {
    const excluded = [];

    body.forEach(bodyEntry => {
        const copyOfBodyEntry = structuredClone(bodyEntry);
        const { guid } = copyOfBodyEntry;
        const properties = store.state.properties[guid];

        if (properties) {
            if (exclude) {
                excluded.push(guid);
            }

            if (properties.__component === "ctrl-fragment") {
                excluded.push(...excludeFragments(copyOfBodyEntry.body || [], store, true));
                copyOfBodyEntry.body = [];
            } else {
                excluded.push(...excludeFragments(copyOfBodyEntry.body || [], store, exclude));
            }
        };

    });

    return excluded;
};

export const saveInterface = (store, exportInterface) => {
    const fragments = [];
    const inputModel = { get: {}, set: {} };
    let properties;
    let isNew = false;
    const namespaces = { get: {}, set: {} };
    const themeColors = () => {
        const theme = {};
        Object.entries(store.state.colorValue).forEach(([color, data]) => {
            if (data.hasOwnProperty("theme") && data.theme) {
                theme[color] = data.value;
            }
        });

        return theme;
    };
    const parseBody = (interfaceBody, ns = []) => {
        interfaceBody.forEach(bodyEntry => {
            const { guid } = bodyEntry;
            const properties = store.state.properties[guid];
            let isTable;
            let isNamespace;
            let configProperties;
            const parsedNamespaces = [...ns];

            if (properties.__component === "ctrl-fragment") {
                fragments.push(properties.fragment);
            } else {
                if (properties.get || properties.set) {
                    configProperties = store.state.components[properties.__component];
                    isTable = properties.__component === "ctrl-data-table";
                    isNamespace = configProperties.namespace;

                    if (isNamespace) {
                        if (parsedNamespaces.length) {
                            if (properties.get) {
                                namespaces.get[guid] = { path: properties.get };
                                namespaces.get[parsedNamespaces[0]][guid] = namespaces.get[guid];
                            }
                            if (properties.set) {
                                namespaces.set[guid] = { path: properties.set };
                                namespaces.set[parsedNamespaces[0]][guid] = namespaces.set[guid];
                            }
                        } else {
                            if (properties.get) {
                                namespaces.get[guid] = { path: properties.get };
                                inputModel.get[guid] = namespaces.get[guid];
                            }
                            if (properties.set) {
                                namespaces.set[guid] = { path: properties.set };
                                inputModel.set[guid] = namespaces.set[guid];
                            }
                        }

                        parsedNamespaces.unshift(guid);
                    } else if (isTable) {
                        const tableObject = { path: properties.get || properties.set };
                        properties.columns.forEach(({ get, field }) => {
                            tableObject[field] = get;
                        });

                        if (parsedNamespaces.length) {
                            if (properties.get) {
                                namespaces.get[parsedNamespaces[0]][guid] = tableObject;
                            }
                            if (properties.set) {
                                namespaces.set[parsedNamespaces[0]][guid] = tableObject;
                            }
                        } else {
                            if (properties.get) {
                                inputModel.get[guid] = tableObject;
                            }
                            if (properties.set) {
                                inputModel.set[guid] = tableObject;
                            }
                        }
                    } else if (parsedNamespaces.length) {
                        if (properties.get) {
                            namespaces.get[parsedNamespaces[0]][guid] = properties.get;
                        }
                        if (properties.set) {
                            namespaces.set[parsedNamespaces[0]][guid] = properties.set;
                        }
                    } else {
                        if (properties.get) {
                            inputModel.get[guid] = properties.get;
                        }
                        if (properties.set) {
                            inputModel.set[guid] = properties.set;
                        }
                    }
                }

                parseBody(bodyEntry.body || [], parsedNamespaces);
            }
        });
    };

    if (store.state.activeInterface) {
        isNew = false;
        properties = store.state.currentInterfaceProperties;

        // properties = store.state.appInterfaces.find(interfaceEntry => interfaceEntry.id === store.state.activeInterface);
    } else {
        isNew = true;
        properties = store.state.currentInterfaceProperties;
        properties.id = uid();

        // properties = store.state.emptyInterface;
    }

    const filteredBody = extend(true, [], store.state.bodyReference.body);
    const excludedComponents = excludeFragments(filteredBody, store);

    const filteredComponents = {};
    Object.entries(store.state.properties).forEach(([key, data]) => {
        if (excludedComponents.indexOf(key) === -1) {
            filteredComponents[key] = data;
        }
    });

    parseBody(filteredBody);

    properties.versionId = store.state.latestVersion;
    properties.processDefinitionId = store.rootState.main.currentApplicationId;

    if (Object.keys(store.state.properties).length) {
        properties.interfaceJson = {
            components: filteredComponents,
            body: filteredBody,
            config: {
                fragments,
                theme: themeColors(),
                aiActions: store.state.aiActions,
                legacyRenderer: store.state.legacyRenderer || false
            }
        };
    } else {
        properties.interfaceJson = {
            components: {},
            body: [],
            config: {
                fragments,
                theme: themeColors(),
                aiActions: store.state.aiActions,
                legacyRenderer: store.state.legacyRenderer || false
            }
        };
    }

    properties.interfaceInputModel = { get: null, save: null };
    if (Object.keys(inputModel.get).length) {
        properties.interfaceInputModel.get = inputModel.get;
    }
    if (Object.keys(inputModel.set).length) {
        properties.interfaceInputModel.save = inputModel.set;
    }

    properties = {
        interfaceTestData: {},
        ownerId: null,
        processImage: null,
        usedOnApps: null,
        ...properties
    };
    if (exportInterface) {
        return properties;
    } else {
        return new Promise((resolve, reject) => {
            $http({ type: "POST", url: urls.guiSave, data: properties }, true)
                .then(({ data }) => {
                    if (data.status) {
                        getInterfaceModel(store, {
                            guid: properties.id,
                            local: false,
                            update: true
                        }).then(interfaceData => {
                            if (isNew) {
                                store.commit("addAppInterface", interfaceData.properties);
                            } else {
                                store.commit("updateAppInterface", { guid: properties.id, data: properties });
                                if (properties.type === "GUI") {
                                    store.commit("removeFragment", properties.id);
                                }
                            }
                            resolve(properties.id);
                        });
                    } else {
                        store.rootState.main.interfaceDirty = false;
                    }
                })
                .catch(() => {
                    reject();
                });
        });
    }
};

export const loadInterfaceData = (store, payload) => {
    const { processInstanceId, guid, plv = false, activityId } = payload;
    const url = payload.perspectiveId ? `/engine/apps/${payload.appId}/consume/perspectives/${payload.perspectiveId}/data/load/gui` : urls.loadInterfaceData;
    const data = { guiId: guid, processInstanceId, fromPLV: plv, activityId };

    return $http({ type: "POST", url, data }, true).then(rsp => rsp.data);
};

export const saveInterfaceData = (store, payload) => {
    const { processInstanceId, guid, data, activityId, taskId } = payload;

    const urlFormat = urls.saveInterfaceData + (payload.isSaveForLater ? "?isSaveForLater=true" : "");
    const sendData = {
        guiId: guid,
        processInstanceId,
        data,
        activityId,
        taskId
    };

    return new Promise(resolve => {
        $http({ type: "POST", url: urlFormat, data: sendData }, true)
            .then(result => resolve(result.status === 200))
            .catch(() => resolve(false));
    });
};

export const submitActions = (store, activityId) => {
    const url = formatStr(urls.getActions, activityId);
    return $http({ type: "GET", url }, true)
        .then(({ data }) => data)
        .catch(error => {
            const { response: { status } = {} } = error;

            if (status === 403) {
                sessionStorage.setItem("sessionExpired", true);
                window.location.assign("/login");
            }
        });
};

export const dataStoreRequest = (store, {url, type, payload: data}) => {
    return $http({type, url, data}, true)
        .then(({data}) => data)
        .catch(error => {
            console.error(error);
            return {};
        })
}

export const claimTask = (store, taskId) => {
    const url = formatStr(urls.claimTask, taskId);
    const data = { taskId };
    return new Promise(resolve => {
        $http(
            {
                type: "POST",
                url,
                data,
                noNotify: true
            },
            true
        )
            .then(result => resolve(result))
            .catch(err => {
                if (err.response.status === 409) {
                    const id = window.localStorage.getItem("taskId");
                    window.localStorage.setItem("conditionType", false);
                    window.location.assign(`/${PLATFORM_BASE_PATH}/task?id=${id}`);
                }

                if (err.response.status === 404) {
                    Dialog.create({
                        message: i18n.t("tasks.taskNotFound")
                    });
                }

                if (err.response.status === 401) {
                    Dialog.create({
                        message: i18n.t("tasks.noRightsToClaimTask")
                    });
                }

                if (err.response.status === 400) {
                    Dialog.create({
                        message: i18n.t("tasks.taskFinalized")
                    });
                }

                if (err.response.status === 500) {
                    Dialog.create({
                        message: i18n.t("tasks.taskFinalized")
                    });
                }
                resolve(false);
            });
    });
};

export const guiSubmit = (store, payload) => {
    const { actionId, comment, taskId, taskType } = payload;
    let promise;
    let data;
    let url;
    if (taskType === "TASK_PLUGIN") {
        url = urls.guiSubmit;
        data = { actionId, comment, taskId };
    } else if (taskType === "APPROVALLEVEL_PLUGIN") {
        url = urls.guiApprovalSubmit;
        data = { actionCode: actionId, comment, taskId };
    } else {
        url = urls.guiSubmit;
        data = { actionId, comment, taskId };
    }

    promise = $http({ type: "POST", url, data }, true);
    promise = promise.then(({ data1 }) => data1);
    return promise;
};

export const getRawCoreAPIs = store =>
    $http(
        {
            type: "GET",
            url: urls.coreAPIs
        },
        true
    ).then(({ data }) => {
        store.commit("rawCoreAPIs", data);
        return data;
    });

export const getRawExternalAPIs = (store) => {
    const applicationId = store.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apis/mappings?applicationId=${applicationId}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            ({ data }) => {
                store.commit("rawExternalAPIs", data);
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const getAllEXternalApis = (store, appId) => {
    const applicationId =  appId || store.rootState.apps.currentApp.id
    const params = {
        type: "GET",
        url: `/integration/ws/all?applicationId=${applicationId}`
    }
     return $http(params, true).then(
       ({data})  => {
            store.commit("rawExternalAPIs", data);
            return data;
        },
        error => error
    );
}

export const getRawSystemVariables = store =>
    $http(
        {
            url: urls.systemVariables,
            type: "GET"
        },
        true
    ).then(({ data }) => {
        store.commit("rawSystemVariables", data);
        return data;
    });

export const getCatalogData = (store, payload) => {
    let catalog;
    const url = formatStr(urls.catalogLoad, store.state.latestVersion, store.rootState.apps.currentApp.id);

    if (typeof payload === "string") {
        catalog = payload;
    } else {
        ({ catalog } = payload);
    }

    return $http(
        {
            type: "POST",
            url,
            data: {
                type: catalog,
                filters: { active: true },
                options: {
                    ascending: true,
                    all_languages: true,
                    sort_by: "code"
                }
            }
        },
        true
    ).then(({ data }) => data);
};

export const callIntegrationAPI = (store, payload) => {
    const { api, request, fromTesting } = payload;
    const counter = api.split('.').length - 1;
    let webService = null, operation = null;
    if (counter > 1) {
        const arr = api.split(".");
        operation = arr.pop();
        webService = arr.join(".");
    } else {
        [webService, operation] = api.split(".");
    }
    const versionId = store.state.latestVersion;
    const applicationId = store.rootState.apps.currentApp.id;
    const apiTest = store.state.raw.externalAPIs.paths.find(api => api.name === webService);
    const url = (fromTesting && !apiTest.system) ? formatStr(urls.apiTesting, apiTest.id, operation, applicationId) : formatStr(urls.apiIntegration, versionId, applicationId, webService, operation);
    const httpObject = {
        type: "POST",
        url,
        data: request
    };

    if (!fromTesting) {
        httpObject.headers = {
            processInstanceId: store.state.processInstanceId,
            activityId: store.state.activityId,
            taskId: store.state.taskId
        };
    }

    return $http(httpObject, true).then(({ data }) => data);
};

export const callMetamaskIntegration = (store, payload) => {
    const req = {
        type: "POST",
        url: "/blockchain/metamask/function/generate",
        data: payload
    };
    return $http(req, true).then(
        data => data,
        error => error
    );
};
export const getSystemVariablesForTasksExport = store =>
    $http(
        {
            url: urls.systemTasksVariablesExtended,
            type: "GET"
        },
        true
    ).then(({ data }) => {
        store.commit("rawSystemVariablesForTasksExport", data);
        return data;
    });

export const getSystemVariablesForInstancesExport = store =>
    $http(
        {
            url: urls.systemInstancesVariablesExtended,
            type: "GET"
        },
        true
    ).then(({ data }) => {
        store.commit("rawSystemVariablesForInstancesExport", data);
        return data;
    });

export const getCommitId = (context, interfaceId) => {
    const appId = context.rootState.apps.currentApp.id;
    const req = {
        url: `/design/app/${appId}/gui/${interfaceId}/last-commit-id`,
        type: "GET",
        data: {}
    };
    return new Promise(resolve => {
        $http(req, true)
            .then(data => {
                if (data) {
                    resolve(data);
                }
            })
            .catch(() => {
                resolve(false);
            });
    });
};

export const exportInterfaceAction = (store, payload) => {
    const req = {
        url: `/design/guis/export`,
        type: "POST",
        data: payload,
        headers: {
            "Content-type": "application/json;charset=UTF-8",
            Accept: "application/octet-stream"
        }
    };
    return $http(req, true).then(
        data => data,
        error => error
    );
};

export const getHistoryData = (store, payload) => {
    const params = {
        url: "/design/version/history",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const askAi = (store, payload) => {
    const params = {
        url: payload.type === "OAI" ? "/aiml/openai/ask" : "/aiml/azure/ask",
        type: "POST",
        data: payload.data,
        noNotify: true
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const docAssistantAI = (store, payload) => {
    const params = {
        url: "/aiml/assistants/file-search",
        type: "POST",
        data: payload,
        noNotify: true
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const exportAIConv = (store, payload) => {
    $http({
        type: "POST",
        url: "/aiml/assistants/export-conversation",
        data: { conversation: payload.conversation },
        noNotify: true,
        responseType: 'arraybuffer'
    }, true).then(rsp => {
        const newBlob = new Blob([rsp.data], { type: "application/pdf" });
        const data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = `${payload.name} - ${payload.dateTime}.pdf`;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);
        document.body.removeChild(link);
    }).catch(error => {
        const errorData = JSON.parse(Buffer.from(error.response.data).toString("utf8"));
        let message = errorData.error;
        if (errorData.error.includes("list attribute outside of")) {
            message = i18n.t("froala.failedPreview");
        }
        Vue.prototype.$toast.showNotify({
            type: "error",
            message
        });
        console.error(errorData);
    });
};

export const docUploadAI = (store, payload) => {
    const params = {
        url: "/data/attachment/file/from-builder",
        type: "POST",
        data: payload,
        noNotify: true
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const aiEmbeddings = (store, payload) => {
    const params = {
        url: payload.type === "OAI" ? `/aiml/openai/embeddings/gui?guiId=${payload.id}` : `/aiml/azure/embeddings/gui?guiId=${payload.id}`,
        type: "POST",
        data: "",
        noNotify: true
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                data => data,
                resolve(data);
            },
            error => reject(error)
        );
    });
}

export const getHistoryPreviewData = (store, payload) => {
    const params = {
        url: "/design/guis/preview",
        type: "POST",
        data: payload
    };
    let promise;
    let guid = payload.elementId;
    promise = new Promise(resolve => {
        $http( params, true).then(({ data }) => {
            const { interfaceJson, interfaceInputModel, interfaceTestData, ...properties } = data;
            if (!interfaceJson.config) {
                interfaceJson.config = {};
                interfaceJson.config.fragments = [];
            }

            backwardsCompatibilityUpdates(data);

            const dataModel = { model: { interfaceJson, interfaceInputModel, interfaceTestData }, dirty: false };
            if (properties.type === "FRAGMENT") {
                store.commit("addFragment", { id: guid, model: dataModel.model, data: properties });
            }
            store.commit("setInterfaceModel", { guid, dataModel });
            if (interfaceJson) {
                loadFragments(store, interfaceJson.config.fragments).then(() => {
                    resolve(extend(true, {}, dataModel, { properties }));
                });
            }
        });
    });
    return promise;
}

export const getHistoryDMPreviewData = (store, payload) => {
    const params = {
        url: "/design/dataModel/preview",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const getHistoryAPIPreviewData = (store, payload) => {
    const params = {
        url: "/design/apis/preview",
        type: "POST",
        data: payload
    }
    return $http(params, true).then( data => data, error => console.log(error))
}

export const getHistoryCredentialsPreviewData = (store, payload) => {
    const params = {
        url: "/design/credentials/preview",
        type: "POST",
        data: payload
    }
    return $http(params, true).then( data => data, error => console.log(error))
}

export const saveDeleteNote = (store, payload) => {
    const params = {
        url: "/design/version/note",
        type: "POST",
        data:payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const getNote = (store, payload ) => {
    const params = {
        url: `/design/version/note?module=${payload.module}&applicationId=${payload.applicationId}&elementId=${payload.elementId}&commitId=${payload.commitId}`,
        type: "GET"
    }
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const recoverInterface = (store, payload) => {
    const params = {
        url: "/design/guis/recover",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
}

export const renameInterface = (store, payload) => {
    const params = {
        url: "/design/guis/rename",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data
    );
}
